<form [formGroup]="form">
  <section class="content">
    <h5 class="content--title">{{ 'chooseVehicleToReplace' | i18next }}</h5>
    <div class="content--info">
      <mat-radio-group
        color="primary"
        class="content--info__radioContainer"
        formControlName="vehicle"
        (change)="selectReplacementVehicle()"
      >
        <mat-radio-button
          *ngFor="let vehicle of vehiclesArr; index as i"
          id="{{ vehicle.plateNumber }}"
          value="{{ vehicle.plateNumber }}"
          [checked]="i === 0"
          class="radioBtn"
        >
          {{ vehicle.model }} {{ vehicle.plateNumber || vehicle.VIN }}
          {{ vehicle.color }}
          <span
            class="deliveredDate"
            *ngIf="!!vehicle.deliveryDate && vehicle.deliveryDate !== 'null'"
          >
            {{ 'deliveredDate' | i18next }} {{ vehicle.deliveryDate }}</span
          >
          <span
            class="factoryAccess"
            *ngIf="
              requestType === requestTypeEnum.dotArr ||
              requestType === requestTypeEnum.campaigns ||
              requestType === requestTypeEnum.function
            "
            >{{
              vehicle.factoryAccess
                ? ('withFactoryAccess' | i18next)
                : ('withoutFactoryAccess' | i18next)
            }}</span
          >
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </section>
  <!-- Kms estimados   -->
  <section
    class="content"
    *ngIf="requestType !== requestTypeEnum.innerRoute && carType !== 'flota'"
  >
    <h5 class="content--title">
      {{ 'requestKmsReturn' | i18next }}
    </h5>
    <div class="content--item">
      <mat-form-field>
        <mat-label for="estimatedKms">{{
          'requestEstimatedKms' | i18next
        }}</mat-label>
        <input
          matInput
          type="text"
          name="estimatedKms"
          formControlName="estimatedKms"
          (change)="changeEstimatedKms()"
        />
      </mat-form-field>
    </div>
    <div
      class="error"
      *ngIf="errorRequest && form.controls['estimatedKms'].valid"
    >
      <p>{{ 'errorRequest' | i18next }}</p>
      <p *ngIf="tmaimgDate">
        {{ 'errorVehicle' | i18next: { months: tmaimgDate } }}
      </p>
      <p *ngIf="tmaimgKms">
        {{ 'errorDate' | i18next: { kms: tmaimgKms } }}
      </p>
    </div>
  </section>
  <div class="content--btnContainer">
    <button
      class="content--btnContainer__btn btn confirm"
      matStepperNext
      mat-button
      [disabled]="
        (form.invalid && carType !== 'flota') ||
        (errorRequest && carType !== 'flota')
      "
      (click)="nextStep()"
      [style]="
        (form.invalid && carType !== 'flota') ||
        (errorRequest && carType !== 'flota')
          ? 'background-color: #565554'
          : 'background-color: #2c2a29'
      "
    >
      {{ 'btnContinue' | i18next | uppercase }}
    </button>
    <button
      class="content--btnContainer__btn btn cancel"
      [style]="'background-color: #2c2a29'"
      mat-button
      (click)="backStep()"
    >
      {{ 'btnReturn' | i18next | uppercase }}
    </button>
  </div>
</form>
